import formatStringByPattern from "format-string-by-pattern";

const fein = (value) => {
  const onlyNumbers = value.replace(/[^\d]/g, "");
  if (!!value.trim() && !!onlyNumbers) {
    return formatStringByPattern("99-9999999", onlyNumbers);
  }
  return null;
};

export const positiveNumber = (value) => {
  if (!value && value?.trim() !== "") {
    return value;
  } else if (value?.trim() === "") {
    return null;
  }
  return value.replace(/[^\d.]/g, "");
};

export const positiveWholeNumber = (value) => {
  if (!value && value?.trim() !== "") {
    return value;
  } else if (value?.trim() === "") {
    return null;
  }
  return value
    .replace(/\./g, "")
    .replace(/-/g, "")
    .replace(/[^\d.]/g, "");
};

export const positiveWholeNumberToInt = (value) => {
  value = value
    .replace(/\./g, "")
    .replace(/-/g, "")
    .replace(/[^\d.]/g, "");
  if (value?.trim() === "") {
    return null;
  }
  if (!value) {
    return value;
  }
  return parseInt(value);
};

export const wholeNumber = (value) => {
  if (!value && value?.trim() !== "") {
    return value;
  } else if (value?.trim() === "") {
    return null;
  }
  return value.replace(/\./g, "").replace(/[^\d.]/g, "");
};

export const noNumbers = (value) => {
  if (!value) {
    return value;
  }
  return value.replace(/\d/g, "");
};

export const noSpecialChars = (value) => {
  if (!value) {
    return value;
  }
  return value.replace(/([#$%*+=?@^_{|}~<>])/g, "");
};

export const noBadChars = (value) => {
  if (!value) {
    return value;
  }
  return value.replace(/([ʼ])/g, "");
};

const parser = (name, schemaProps, formApi) => {
  if (schemaProps && formApi) {
    // dynamic logic here
  }
  const parsers = {
    fein: fein,
    positiveNumber: positiveNumber,
    wholeNumber: wholeNumber,
    positiveWholeNumber: positiveWholeNumber,
    positiveWholeNumberToInt: positiveWholeNumberToInt,
    noNumbers: noNumbers,
    noSpecialChars: noSpecialChars,
    noBadChars: noBadChars,
  };
  return parsers[name];
};

export default parser;
